import { getWechatJsSdkConfig } from '@/api/wechat'

const WECHAT_SDK_URL = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js'

let sdkLoadPromise
let sdkReadyPromise
let configuredUrl = ''

export function isWechatBrowser() {
  return typeof navigator !== 'undefined' && /MicroMessenger/i.test(navigator.userAgent)
}

export function getWechatShareUrl() {
  if (typeof window === 'undefined') return ''
  const url = new URL(window.location.href)
  url.hash = ''
  return url.toString()
}

export async function updateWechatAppMessageShareData({ title, desc, link, imgUrl }) {
  if (!isWechatBrowser()) return false

  const shareUrl = getWechatShareUrl()
  const wx = await ensureWechatReady(shareUrl)
  await invokeWechatShare(wx, {
    title: String(title || '共享文档'),
    desc: String(desc || 'VitaeAI 共享文档'),
    link: String(link || shareUrl),
    imgUrl: String(imgUrl || new URL('/logos/vitaeai-transparent.png', window.location.origin).href)
  })
  return true
}

async function ensureWechatReady(url) {
  if (sdkReadyPromise && configuredUrl === url) return sdkReadyPromise

  configuredUrl = url
  sdkReadyPromise = (async () => {
    const sdk = await loadWechatSdk()
    const result = await getWechatJsSdkConfig(url)
    const config = result?.data || result
    if (!config?.appId || !config?.timestamp || !config?.nonceStr || !config?.signature) {
      throw new Error('微信分享签名配置不完整')
    }

    await new Promise((resolve, reject) => {
      sdk.config({
        debug: false,
        appId: config.appId,
        timestamp: Number(config.timestamp),
        nonceStr: config.nonceStr,
        signature: config.signature,
        jsApiList: ['updateAppMessageShareData']
      })
      sdk.ready(resolve)
      sdk.error(error => reject(new Error(error?.errMsg || '微信 JS-SDK 配置失败')))
    })
    return sdk
  })()

  try {
    return await sdkReadyPromise
  } catch (error) {
    sdkReadyPromise = undefined
    configuredUrl = ''
    throw error
  }
}

function loadWechatSdk() {
  if (window.wx) return Promise.resolve(window.wx)
  if (sdkLoadPromise) return sdkLoadPromise

  sdkLoadPromise = new Promise((resolve, reject) => {
    const existingScript = document.querySelector(`script[src="${WECHAT_SDK_URL}"]`)
    if (existingScript) {
      existingScript.addEventListener('load', () => resolve(window.wx), { once: true })
      existingScript.addEventListener('error', () => reject(new Error('微信 JS-SDK 加载失败')), { once: true })
      return
    }

    const script = document.createElement('script')
    script.src = WECHAT_SDK_URL
    script.async = true
    script.onload = () => window.wx ? resolve(window.wx) : reject(new Error('微信 JS-SDK 未初始化'))
    script.onerror = () => reject(new Error('微信 JS-SDK 加载失败'))
    document.head.appendChild(script)
  })

  return sdkLoadPromise
}

function invokeWechatShare(wx, data) {
  return new Promise((resolve, reject) => {
    wx.updateAppMessageShareData({
      ...data,
      success: resolve,
      cancel: resolve,
      fail: error => reject(new Error(error?.errMsg || '微信好友分享配置失败'))
    })
  })
}
